import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import SortUi from '@/js/components/retail-store/sort.vue';

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const sort = params.get('sort');
  const sortEl = document.querySelector('sort-ui') as HTMLElement;

  if (sort) {
    sortEl.scrollIntoView({
      behavior: 'smooth',
    });
  }

  createApp({
    render: () =>
      h(SortUi, {
        sort: sortEl.dataset.sort,
      }),
  }).mount(sortEl);
});
